// removed by extract-text-webpack-plugin
module.exports = {"container":"_3D4Y-fLpWuKohVPZ3G9Jfa","actions":"_2pp1B8bDMAaFjN1A1BH9CC"};


//////////////////
// WEBPACK FOOTER
// ./~/extract-text-webpack-plugin/loader.js?{"omit":1,"remove":true}!./~/vue-style-loader!./~/css-loader?{"minimize":true,"sourceMap":true,"localIdentName":"[hash:base64]","modules":true,"importLoaders":true}!./~/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-86a095a8","scoped":false,"hasInlineConfig":false}!./~/less-loader/dist/cjs.js?{"sourceMap":true}!./src/components/sms/contact/contact.less
// module id = cUov
// module chunks = 1